import { useLatestRegistryResultBridge } from '@app/pages/Leads/model';

import { useLeadsRegistrySettings } from './useLeadsRegistrySettings';

import type { LeadsRegistryFilterScope } from '../model/types';

export const useLeadsRegistryHeader = (
  scope: LeadsRegistryFilterScope = 'registry'
) => {
  const {
    incomingMessageSoundToggleHandler,
    isIncomingMessageSoundEnabled,
    loadBatchSize,
    loadBatchSizeChangeHandler,
    loadBatchSizeOptions,
    maxVisibleColumns,
    maxVisibleColumnsChangeHandler,
    maxVisibleColumnsOptions,
  } = useLeadsRegistrySettings(scope);

  const { leads, totalCount } = useLatestRegistryResultBridge();

  return {
    incomingMessageSoundToggleHandler,
    isIncomingMessageSoundEnabled,
    loadBatchSize,
    loadBatchSizeChangeHandler,
    loadBatchSizeOptions,
    maxVisibleColumns,
    maxVisibleColumnsChangeHandler,
    maxVisibleColumnsOptions,
    loadedCount: leads.length,
    totalCount: totalCount ?? 0,
  };
};
